import Page from '@episerver/spa-core/Page';
import HtmlTextPageData from 'app/Models/Content/HtmlTextPageData';
import React, {useRef, useEffect} from 'react';
import {prepareNewWindowUrl} from 'app/utilities/StringHelpers/StringHelpers';
import HorizonalScroll from './HorizonalScroll';

type HtmlTextPageBodyProps = {body: string; context: any};
const HtmlTextPageBody = ({body, context}: HtmlTextPageBodyProps) => {
  const ref = useRef<HTMLParagraphElement>();

  useEffect(() => {
    const tables = Array.from(ref.current.querySelectorAll('table'));
    const listensers = tables.map((table) => HorizonalScroll(table));
    const handleResize = () => listensers.forEach((func) => func());

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <p
      ref={ref}
      className='HtmlTextPage__body'
      onClickCapture={(e) => {
        const href = (e.target as HTMLElement).closest('a')?.getAttribute('href');
        if (!href || href[0] === '#' || !/\.pdf|globalassets|contentassets/i.test(href)) return;
        e.preventDefault();
        e.stopPropagation();
        prepareNewWindowUrl(href, context);
      }}
      dangerouslySetInnerHTML={{__html: body}}
    />
  );
};

export default class HtmlTextPage extends Page<HtmlTextPageData> {
  render() {
    const {
      data: {title, subtitle, mainBody},
    } = this.props;

    return (
      <div className='HtmlTextPage'>
        <h2>{title.value}</h2>
        <p className='HtmlTextPage__subtitle'>{subtitle.value}</p>
        <HtmlTextPageBody body={mainBody.value} context={this.props.context} />
      </div>
    );
  }
}
